import React, { useCallback, useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Snackbar,
  TextField,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import UserService from "../../../services/api/user.service";
import AuthService from "../../../services/api/auth.service";
import isEmpty from "../../../utils/isempty.utils";
import { IChangePasswordRequest } from "../../../models/entities/IChangePasswordRequest";




export const AccountProfileDetails = () => {
  const dispatch: any = useDispatch();
  const user = useSelector((state: any) => state.userReducer);
  const [openFailed, setOpenFailed] = useState(false);
  const [openCreated, setOpenCreated] = useState(false);
  const [message, setMessage] = useState("");
  const [token, setToken] = useState<any>("");

  const [values, setValues] = useState<any>({
    username: "dbadmin",
    mail: "contact@leblr.fr",
    currentPassword: "",
    newPassword: "",
    confirmationPassword: ""

  });

  const handleChange = useCallback((event: { target: { name: any; value: any } }) => {
    setValues((prevState: any) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  }, []);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    console.log(values)
    if(values.newPassword != values.confirmationPassword) {
      setMessage("Veuillez rentre le meme mot de passe")
    } else {
      requestModifyApi(values, token);
    }
  };

  const handleCloseSnackbar = (event: any, reason: any) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenFailed(false);
  };

  const requestModifyApi = (data: IChangePasswordRequest, token: string) => {
    UserService.updatePassword(data, token)
      .then((r) => {
        if (r.status === 204) {
          setOpenCreated(true);
          setMessage("Compte mise a jours");
          setTimeout(() => {
            setOpenCreated(false);
          }, 1000);
        }
      })
      .catch((err) => {
        setOpenFailed(true);
        setMessage("Compte non récuperer");
        setTimeout(() => {
          setOpenFailed(false);
        }, 1000);
      });
  };

  useEffect(() => {
    if (!isEmpty(user)) {
      setToken(AuthService.getUserConnected());
    }
    setValues({
      username: "dbadmin",
      mail: "contact@leblr.fr",
    });
  }, [user]);

  return (
    <>
      <form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Card sx={{ borderRadius: 10, padding: 5 }}>
          <CardHeader
            subheader="Information du profile que vous pouvez editer"
            title="Compte"
            sx={{ marginBottom: "20px" }}
          />
          <CardContent sx={{ pt: 0 }}>
            <Box sx={{ m: -1.5 }}>
              <Grid container spacing={3}>
                <Grid xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="User Name"
                    name="username"
                    onChange={handleChange}
                    required
                    value={values.username}
                    disabled
                  />
                </Grid>
                <Grid xs={12} md={6}>
                  <TextField fullWidth label="Email" name="mail" onChange={handleChange} required value={values.mail} disabled />
                </Grid>
                <Grid xs={12} md={6} style={{marginTop:20}}>
                <TextField
                    fullWidth
                    label="Ancien Password"
                    name="currentPassword"
                    type="password"
                    onChange={handleChange}
                    required
                    value={values.currentPassword}
                  />
                </Grid>
                <Grid xs={12} md={6} style={{marginTop:20}}>
                <TextField
                    fullWidth
                    label="Nouveau Password"
                    name="newPassword"
                    type="password"
                    onChange={handleChange}
                    value={values.newPassword}
                    required
                  />
                  <TextField
                    fullWidth
                    label="Confirmation Password"
                    name="confirmationPassword"
                    type="password"
                    onChange={handleChange}
                    value={values.confirmationPassword}
                    required
                  />
                </Grid>
              </Grid>
            </Box>
          </CardContent>
          <Divider />
          <CardActions sx={{ justifyContent: "flex-end", marginTop: "10px" }}>
            <Button variant="contained" onClick={handleSubmit} sx={{ background: "rgb(34, 10, 110)" }}>
              Sauvegarder
            </Button>
          </CardActions>
        </Card>
      </form>
      <Snackbar open={openCreated} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert severity="success" sx={{ width: "100%" }}>
          {message}
        </Alert>
      </Snackbar>
      <Snackbar open={openFailed} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert severity="error" sx={{ width: "100%" }}>
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};
